import { Dispatch } from '@reduxjs/toolkit';
import { filter, keyBy, uniqBy } from 'lodash/fp';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { Environment } from 'dashboard/models/environment';
import { Exporter } from 'dashboard/models/exporter';
import { User } from 'dashboard/models/user';
import { saveExporters, setExporterDetails } from 'dashboard/redux/actions/exporters';
import { ApiEndpoint, ApiModel, PaginationParams } from 'lib/interfaces/api';

export function loadExportersList(currentPage: number, pageSize: number, environment: Environment) {
  return async (dispatch: Dispatch) => {
    const params = {
      filter: {
        'environment-id': environment.id,
      },
      page: {
        number: currentPage,
        size: pageSize,
      },
    };

    const exportersResponse = await SessionClientDashboard.listResource<Exporter, PaginationParams>(
      ApiEndpoint.Exporter,
      params,
    );

    const exporters = exportersResponse.data;
    const paginationParams = exportersResponse.meta;
    const includedItemsMap = keyBy('id', exportersResponse.included);

    const allUsers = filter(
      (apiRelationship) => apiRelationship.type === ApiModel.User,
      includedItemsMap,
    ) as User[];
    const users = uniqBy('id', allUsers);
    dispatch(setExporterDetails(users));
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    dispatch(saveExporters(exporters, paginationParams));
  };
}
